import { render, staticRenderFns } from "./CarouselTicker.vue?vue&type=template&id=df9dc41c&scoped=true"
import script from "./CarouselTicker.vue?vue&type=script&lang=js"
export * from "./CarouselTicker.vue?vue&type=script&lang=js"
import style0 from "./CarouselTicker.vue?vue&type=style&index=0&id=df9dc41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9dc41c",
  null
  
)

export default component.exports